// extracted by mini-css-extract-plugin
export default {"caption":"_1JgkCXFaj4v9df4IQqVr2L"};